export interface ValidationErrorItem {
  field: string;
  message?: string;
  fieldId?: string;
}

export interface ValidationErrorSection {
  title: string;
  errors: ValidationErrorItem[];
}

type ValidationFieldIdResolver = (message: string) => string | undefined;

export function validationSectionsFromMessages(
  sections: { title: string; errors: string[] }[],
  fieldIdResolver: ValidationFieldIdResolver = getFieldId,
): ValidationErrorSection[] {
  return sections
    .filter(section => section.errors.length > 0)
    .map(section => ({
      title: section.title,
      errors: section.errors.map(message => ({
        field: getFieldName(message),
        message: getErrorDetail(message),
        fieldId: fieldIdResolver(message),
      })),
    }));
}

function getFieldName(message: string): string {
  const withoutContext = message.includes(':')
    ? message.substring(message.lastIndexOf(':') + 1).trim()
    : message.trim();

  return withoutContext
    .replace(/\s*\([^)]*\)\s*$/i, '')
    .replace(/\s+(è|e|non è)\s+obbligatori[aoe]?/i, '')
    .replace(/\s+non è valido[ao]?/i, '')
    .replace(/\s+non è valida/i, '')
    .replace(/\s+obbligatori[aoe]?$/i, '')
    .trim();
}

function getErrorDetail(message: string): string | undefined {
  const withoutContext = message.includes(':')
    ? message.substring(message.lastIndexOf(':') + 1).trim()
    : message.trim();
  const fieldName = getFieldName(message);
  const detail = withoutContext.substring(fieldName.length).trim();
  const normalizedDetail = detail.replace(/^\(|\)$/g, '').trim();

  return normalizedDetail || undefined;
}

function getFieldId(message: string): string | undefined {
  const normalized = message.toLowerCase();
  const idByText: [string, string][] = [
    ['inizio attività', 'activity-start-date'],
    ['numero iscrizione albo nazionale', 'national-registration'],
    ['imprese per le quali lavora', 'companies-worked'],
    ['territorio operativo', 'operating-territories'],
    ['tipo via', 'op-street-type'],
    ['nome via', 'op-street-name'],
    ['numero', 'op-street-number'],
    ['cap', 'op-zipcode'],
    ['regione', 'op-region'],
    ['provincia', 'op-province'],
    ['comune', 'op-municipality'],
    ['data di nascita', 'birth-date'],
    ['codice fiscale', 'fiscal-code'],
    ['mail personale', 'personal-email'],
    ['specializzazione', 'specialization'],
    ['ordine professionale', 'professional-order'],
    ['data iscrizione', 'order-registration-date'],
    ['numero polizza rct', 'rct-policy-number'],
  ];

  return idByText.find(([text]) => normalized.includes(text))?.[1];
}